import client from '../httpClient';

const allocationSettingGetOnAreaCodeApi = (areaCode) => {
  return client.get(`/allocation-settings/${areaCode}`);
};

export default allocationSettingGetOnAreaCodeApi;
